import React from "react";
import "datatables.net-bs4/js/dataTables.bootstrap4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import Breadcrumb from "./Breadcrumb";
import Currierpriceeditcontent from "./Currierpriceeditcontent";

export const Content = (props) => {
  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-md-12">
          <Currierpriceeditcontent />
        </div>
      </div>
    </div>
  );
};

export default Content;
